import styled from 'styled-components';

const ModalBody = styled.div`
  padding: 1.25rem;
  overflow-y: auto;
  max-height: calc(90vh - 80px);
`;

export default ModalBody;
